export default "__VITE_ASSET__DPK$MQce__$_?inline__"